export const GET_BOOKINGS = "GET_BOOKINGS"
export const GET_BOOKINGS_SUCCESS = "GET_BOOKINGS_SUCCESS"
export const GET_BOOKING_DETAILS = "GET_BOOKING_DETAILS"
export const GET_BOOKING_DETAILS_SUCCESS = "GET_BOOKING_DETAILS_SUCCESS"

export const API_ERROR = "BOOKINGS_API_ERROR"
